<h2 mat-dialog-title id="medlem-gjenåpnetilgang-dialog-tittel">{{ "Åpne tilgang for medlem"|translate }}</h2>
<mat-dialog-content class="skjema">
  <p>{{'Åpne tilgang for medlem {navn}'|translate: {navn: medlem.navn} }}</p>
  <mat-slide-toggle [formControl]="skjema.controls.oppdaterMoetemal"
                    class="oppdater-moetemal e2e-oppdaterMoetemal"
                    matTooltip="{{'Fører til at gruppemedlemmet blir lagt til i møtemal og alle fremtidige møter som deltaker'|translate}}">
    {{ 'Skal som hovedregel delta i møtene'|translate }}
  </mat-slide-toggle>
  <mat-slide-toggle [formControl]="skjema.controls.sendInnkallingTilMoeter"
                    class="oppdater-moetemal e2e-sendInnkallingTilMoeter"
                    matTooltip="{{'Skru av denne dersom du ikke ønsker å sende innkalling til møter nå'|translate}}">
    @if (antallMoeterDetSkalSendesInnkallingTilMoeter() == 1) {
      {{ 'Send innkalling til 1 møte'|translate }}
    } @else {
      {{ 'Send innkalling til {antallMoter} møter'|translate: {antallMoter: antallMoeterDetSkalSendesInnkallingTilMoeter()} }}
    }
  </mat-slide-toggle>
  <mat-slide-toggle [formControl]="skjema.controls.skalSignereSomStandard"
                    class="oppdater-moetemal e2e-skalSignereSomStandard"
                    matTooltip="{{'Fører til at gruppemedlemmet blir lagt til i møtemal og alle fremtidige møter som signatar'|translate}}">
    {{ 'Skal som hovedregel signere protokoller/referater'|translate }}
  </mat-slide-toggle>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
  <button mat-raised-button color="primary" type="button" (click)="gjenaapne()" [disabled]="lagrer() || skjema.invalid"
          [visSpinner]="lagrer()" spinnerTekst="{{'Deaktiverer...'|translate}}" class="e2e-gjenaapnetilgang">
    {{ "Gjenåpne tilgang"|translate }}
  </button>
</mat-dialog-actions>
